function isCMS() {
    // window.wp is a reference to Wordpress' global API.
    // It will only be available inside the CMS editor.
    return typeof window !== 'undefined'
        && !!(window.wp);
}

export default isCMS;